// @ts-nocheck
import { FC, useContext } from "react";
import { createUseStyles } from "react-jss";
import { CardComponentProps } from "../../interface";
import { defaultCardComponentProps } from "../../constants/globalVariable";
import { getCardStyle } from "../../constants/globalFunctions";
import IconComponent from "../../icons";
import { ThemeContext } from "../../../ProviderApp";
import { THEME_DARK, THEME_LIGHT } from "../../../App.constant";
import DropdownButtonComponent from "@CubeComponents/form/DropdownButtonComponent";

const useStyles = createUseStyles({
  card: (props) => getCardStyle(props.width as any, props.background as any, props.textColor as any),
  ellipcise: (props) => ({
    border: "none",
    display: "flex",
    padding: "var(--size-0)",
    background: props.background,
    color: props.textColor,
  }),
  DotIcon: (props) => ({
    background: props.headerBackgroundColor,
  }),
});

const CardComponent: FC<CardComponentProps> = (props: CardComponentProps) => {
  /******************* 
    @Purpose : Card Component
    @Parameter : CardComponentProps
    @Author : Techture
  *******************/

  const themeContext = useContext(ThemeContext);

  const getHeaderBackgroundColor = () => {
    if (props.headerBackgroundColor) {
      return props.headerBackgroundColor;
    } else if (themeContext.themeType == THEME_LIGHT) {
      return "var(--system-colour-44)";
    } else if (themeContext.themeType == THEME_DARK) {
      return "var(--neutral-black)";
    }
  };

  const getContentBackground = () => {
    if (props.background) {
      return props.background;
    } else if (themeContext.themeType == THEME_LIGHT) {
      return "var(--surface-white)";
    } else if (themeContext.themeType == THEME_DARK) {
      return "var(--surface-black)";
    }
  };

  const getTextColor = () => {
    if (themeContext.themeType == THEME_LIGHT) {
      return "var(--primary-text)";
    } else {
      return "var(--surface-neutral)";
    }
  };

  const classes = useStyles({
    ...props,
    headerBackgroundColor: getHeaderBackgroundColor(),
    background: getContentBackground(),
    textColor: getTextColor(),
  }) as any;

  const handleBodyClick = (e: any) => {
    if (props.onClick) {
      props.onClick(e, props.dataBound);
    }
  };

  return (
    <div className={`e-card ${classes.card}`} style={{ height: "100%", justifyContent: "flex-start" }}>
      {props.cardHeaderText ? (
        <div className="e-card-header">
          <div className="e-card-header-content-wrapper w-full flex items-center">
            <div className="e-card-header-title">
              <span data-testid={props.cardHeaderText}>{props.cardHeaderText}</span>
              <span className="e-card-header-share" data-testid={`${props.cardHeaderText}-headerShare`}>
                {props.enableShareIcon && (
                  <span onClick={props.onViewCLick} className={"d-inline-block cursor-pointer"}>
                    <IconComponent
                      name="linkout"
                      toolTipContent={`View all ${props.cardHeaderText}`}
                      position="bottom"
                    />
                  </span>
                )}
              </span>
            </div>
            <div className="e-card-header-link" data-testid={`${props.cardHeaderText}-headerLink`}>
              {/* <a href={headerLink}>{headerLinkText}</a> */}
              <span className="e-card-header-max">
                {props.enableMaxMinIcon && (
                  <span
                    data-testid={`${props.cardHeaderText}-headerMax`}
                    onClick={props.onMaximizeClick}
                    className={"d-inline-block cursor-pointer"}
                  >
                    <IconComponent
                      name={props.maxMinIconName}
                      toolTipContent={props.maxMinIconName == "maximizeIcon" ? "Maximise" : props.maxMinIconName}
                      position="bottom"
                    />
                  </span>
                )}
              </span>
              <span style={{ alignSelf: "baseline" }}>
                {props.enableThreeDotsIcon && (
                  <div onClick={props.onItemsClick} data-testid={`${props.cardHeaderText}-threeDots`}>
                    <DropdownButtonComponent
                      items={props.items}
                      cssClass={`e-caret-hide ${classes.ellipcise}`}
                      select={props.selectDropDownItem}
                      bgColor="transparent"
                    >
                      <IconComponent name="threedots" />
                    </DropdownButtonComponent>
                  </div>
                )}
              </span>
            </div>
          </div>
        </div>
      ) : null}
      <div
        style={props.background ? { background: props.background, position: "relative" } : { position: "relative" }}
        onClick={handleBodyClick}
        className="e-card-content"
        data-testid="cardContent"
      >
        {props.cardBody}
      </div>
    </div>
  );
};
CardComponent.defaultProps = defaultCardComponentProps;
export default CardComponent;
